import { Ng1StateDeclaration } from "@uirouter/angularjs";
import { vsComponentName } from "./names";
import { Injectable } from "angular";
import {
  ChangeJournalObjectIdentifier,
  ChangeJournalViewItemResolver,
} from "./models";

export interface ChangeJournalViewStateDefinitionConfig {
  resolveObjects: Injectable<ChangeJournalViewItemResolver>;
}
export function getChangeJournalViewStateDefinition(
  config: ChangeJournalViewStateDefinitionConfig
): Ng1StateDeclaration {
  return {
    component: vsComponentName,
    url: "/changeLog",
    resolve: {
      objects: config.resolveObjects,
    },
  };

  return {
    url: "/changeLog",
    resolve: {
      objects: config.resolveObjects,
    },
    views: {
      "": {
        component: vsComponentName
      }
    }
  };
}
